import { shouldCollectZipCodeForTaxCalculation } from '@/utils/tax';
import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';

export const useShouldBlockExpressCheckoutButtons = () => {
  const { customer, pricing, addressDetails, template } = useContext(CheckoutContext);
  const shouldCollectZipCode = shouldCollectZipCodeForTaxCalculation(
    customer,
    addressDetails?.zipCode ?? customer.address?.zipCode,
    pricing.priceBreakdown.isTaxValid
  );

  if (template.features.blockExpressWalletsForZipCode && shouldCollectZipCode) {
    return {
      shouldBlockExpressCheckoutButtons: true,
    };
  }

  return {
    shouldBlockExpressCheckoutButtons: false,
  };
};
